import { render, staticRenderFns } from "./Howplace.vue?vue&type=template&id=4f688d09&scoped=true"
import script from "./Howplace.vue?vue&type=script&lang=js"
export * from "./Howplace.vue?vue&type=script&lang=js"
import style0 from "./Howplace.vue?vue&type=style&index=0&id=4f688d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f688d09",
  null
  
)

export default component.exports